import { render, staticRenderFns } from "./approval-set.vue?vue&type=template&id=fa3b7d72&scoped=true"
import script from "./approval-set.vue?vue&type=script&lang=js"
export * from "./approval-set.vue?vue&type=script&lang=js"
import style0 from "./approval-set.vue?vue&type=style&index=0&id=fa3b7d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3b7d72",
  null
  
)

export default component.exports